import { categoryKeyOf, categoryMeta } from "../constants/eventCategory";
export { formatFileSize as fmtSize } from "../../../util/numberFormat";

export {
    WEEK_DAYS,
    getMonthCells,
    getWeekDays,
    isEventOnDay as eventOnDay,
    formatDatetimeLocal as toDatetimeLocal,
} from "../../../util/dateUtils";

/**
 * API 응답에서 배열을 꺼낸다 — 백엔드가 배열을 그대로 주기도, {data:[...]}/{employees:[...]} 처럼
 * 감싸 주기도 해서 캘린더 로더마다 `Array.isArray(x) ? x : (x?.data || x || [])` 를 손으로 반복했다.
 * 한 곳으로 모아 언랩 규칙이 로더마다 미묘하게 달라지지 않게 한다.
 *
 * @param {*} res     응답 본문
 * @param {string} [key] 감싼 경우의 배열 키(예: "employees"). 없으면 data 를 우선 본다.
 */
export function asList(res, key) {
    if (Array.isArray(res)) return res;
    if (!res) return [];
    if (key && Array.isArray(res[key])) return res[key];
    if (Array.isArray(res.data)) return res.data;
    return [];
}

/**
 * 일정 색상 — <b>일정 유형(카테고리)</b> 하나로 결정한다.
 *
 * <p>[예전 방식과 왜 바뀌었나] 전에는 색을 상황에서 추정했다 — 휴가면 노랑, 프로젝트 채널 연동이면 보라,
 * 부서가 있으면 빨강, 나머지는 초록. 그래서 회의·출장·제안 발표가 전부 같은 색이었고, "빨간 건 팀 일정"
 * 처럼 색과 의미가 1:1도 아니었다. 이제 유형이 일정의 값이므로 색도 그 값만 본다 —
 * 체크박스 필터가 쓰는 {@link categoryKeyOf} 와 같은 함수를 거치므로 필터와 색이 어긋날 수 없다.
 */
export function getEventColor(ev) {
    return categoryMeta(categoryKeyOf(ev));
}

/**
 * 프로젝트 채널 연동 일정인가. 합성 매핑이 projectChannelId·isProject 를 둘 다 세팅해서, 예전엔 렌더는
 * projectChannelId 를, 소유권 판정은 isProject 를 봐 기준이 갈렸다. "프로젝트면 제목만·담당자명 생략"
 * 규칙을 한 술어로 모아 세 렌더 지점과 클릭 핸들러가 같은 판정을 쓰게 한다.
 */
export function isProjectEvent(ev) {
    return !!(ev && (ev.projectChannelId || ev.isProject));
}

// (제거됨) getColor / LEAVE_COLOR_MAP / getLeaveColor — 색 결정은 getEventColor 하나로 통일.
//   예전 getColor 는 인자를 무시하고 항상 회색(ETC)을 돌려주는 죽은 스텁이었고, '내 일정'만 이걸 써서
//   같은 일정이 메인 캘린더에선 유형색, 내 일정에선 회색으로 보이는 드리프트가 있었다.

